var moment = require('moment');
/**
 * Created by kaunghtetwin on 12/21/16.
 */
export function count (arr) {
  return arr.length
}



// WEBPACK FOOTER //
// ./src/filters/index.js